module.exports = __webpack_public_path__ + "img/empty-img@2x.b4fb9f29.png";